var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 8.77535V19.6003H20.4088V8.77535H15.2212V3.58723H29.812C30.58 3.58723 31.3092 3.7541 31.9651 4.0541C33.013 4.53259 33.8739 5.34975 34.4076 6.36595C34.7529 7.02337 34.9615 7.76369 34.9952 8.54916C34.9987 8.62411 35.0001 8.69948 35.0001 8.77535Z",
    fill: "#E5534B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 8.77528V9.00146H20.4087V8.54909H34.995C34.9985 8.62403 35 8.69941 35 8.77528Z",
    fill: "#E96666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 19.6003H20.4087V18.9725H34.9998V19.6003Z",
    fill: "#E96666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4075 6.36584H24.4575V4.05399H31.9649C33.0129 4.53249 33.8738 5.34964 34.4075 6.36584ZM23.2889 6.36584H15.7754V4.05399H23.2889V6.36584Z",
    fill: "#EC665A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2212 3.58717C12.3559 3.58717 10.0332 5.90983 10.0332 8.77507V19.4751H20.4091V8.77507C20.4091 5.90983 18.0863 3.58717 15.2212 3.58717Z",
    fill: "#E96666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5356 18.9725V8.77506C10.5356 6.19149 12.6375 4.08972 15.221 4.08972C17.8045 4.08972 19.9063 6.19149 19.9063 8.77506V18.9725H10.5356Z",
    fill: "#B83A44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0691 18.1765H21.3394L34.0691 9.73323V18.1765Z",
    fill: "#E24943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.748047 19.6005H20.4086V18.9726H0.748047V19.6005Z",
    fill: "#DE4E4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.033 19.6005H0V18.9726H10.033V19.6005Z",
    fill: "#F26772"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2891 10.8389H24.445V-7.9155e-05H23.2891V10.8389Z",
    fill: "#F5C761"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4448 3.58716H24.4574V-5.84126e-05H24.4448V3.58716Z",
    fill: "#DFF2F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4574 10.8389H23.8794H24.4448V9.00145H24.4574V10.8389ZM24.4574 8.54908H24.4448V6.36587H24.4574V8.54908ZM24.4574 4.05402H24.4448V3.58715H24.4574V4.05402Z",
    fill: "#D84F49"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4448 9.00146H24.4574V8.54909H24.4448V9.00146Z",
    fill: "#C6434C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4448 6.36584H24.4574V4.05398H24.4448V6.36584Z",
    fill: "#DE6256"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4448 10.8389H23.8794V-7.9155e-05H24.4448V3.58715V4.05402V6.36587V8.54908V9.00145V10.8389Z",
    fill: "#E6B95D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.164 1.40713L24.4448 -7.4625e-05V2.86462L28.164 1.40713Z",
    fill: "#E96666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2739 10.8389C25.2739 11.616 24.6439 12.2461 23.8667 12.2461C23.0896 12.2461 22.4595 11.616 22.4595 10.8389C22.4595 10.0617 23.0896 9.43163 23.8667 9.43163C24.6439 9.43163 25.2739 10.0617 25.2739 10.8389Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4923 10.8389C24.4923 11.1842 24.2124 11.4641 23.867 11.4641C23.5217 11.4641 23.2417 11.1842 23.2417 10.8389C23.2417 10.4935 23.5217 10.2136 23.867 10.2136C24.2124 10.2136 24.4923 10.4935 24.4923 10.8389Z",
    fill: "#181C3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4233 18.9611H1.00488V9.30811H15.4233V18.9611Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00488 18.9611L8.2141 14.1345L15.4233 18.9611H1.00488Z",
    fill: "#F2F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00488 9.30802L8.2141 14.624L15.4233 9.30802H1.00488Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00488 9.30805L8.2141 14.1345L15.4233 9.30805H1.00488Z",
    fill: "#F2F2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0759 10.6028H5.35303V10.3105H11.0759V10.6028Z",
    fill: "#181C3F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0759 11.2117H5.35303V10.9194H11.0759V11.2117Z",
    fill: "#181C3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5e51f70e6a4b22063190ce55939005dc.svg";
export { ForwardRef as ReactComponent };